/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getCarLoanById, getAllAdmins } from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import moment from "moment";
import { FaEdit } from 'react-icons/fa';
import { Row, Col, Button } from "react-bootstrap";

const EditCarViewModal = ({ isOpen, onClose, loanId }) => {
  const { adminId, adminName } = useContext(AuthContext);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    created_id: "",
    created_by: "",
    assigned_to: "",
    status: "",
    employee_type: "",
    rejected_reason: "",
    name: "",
    dob: "",
    email: "",
    mobile: "",
    maritalstatus: "",
    current_address: "",
    city: "",
    state: "",
    pincode: "",
    emergency_contact_phone: "",
    current_bank_name: "",
    branch: "",
    account_type: "",
    account_number: "",
    own_house: "",
    current_loan: "",
    monthly_income: "",
    make_model: "",
    registered_year: "",
    registration_number: "",
    loan_type: "",
    requested_loan_amount: "",
    pan_card: null,
    aadhar_card: null,
    photo: null,
    signature: null,
    cosigner_signature: null,
  });
  const formattedDob = formData.dob
    ? moment(formData.dob).format("DD-MM-YYYY")
    : "";

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await getAllAdmins();
        const filteredAgents = response.filter((admin) => admin.role === "employee");
        setAgents(filteredAgents);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching agents:", error);
      }
    };

    fetchAgents();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      if (loanId && isOpen) {
        try {
          const loan = await getCarLoanById(loanId);
          setFormData({
            created_id: loan.created_id || "",
            created_by: loan.created_by || "",
            assigned_to: loan.assigned_to,
            status: loan.status,
            employee_type: loan.employee_type,
            rejected_reason: loan.rejected_reason || "",
            name: loan.name,
            dob: loan.dob,
            email: loan.email,
            mobile: loan.mobile,
            maritalstatus: loan.maritalstatus,
            current_address: loan.current_address,
            city: loan.city,
            state: loan.state,
            pincode: loan.pincode,
            emergency_contact_phone: loan.emergency_contact_phone,
            current_bank_name: loan.current_bank_name,
            branch: loan.branch,
            account_type: loan.account_type,
            account_number: loan.account_number,
            own_house: loan.own_house,
            current_loan: loan.current_loan,
            monthly_income: loan.monthly_income,
            make_model: loan.make_model,
            registered_year: loan.registered_year,
            registration_number: loan.registration_number,
            loan_type: loan.loan_type,
            requested_loan_amount: loan.requested_loan_amount,
            pan_card: loan.pan_card || null,
            aadhar_card: loan.aadhar_card || null,
            photo: loan.photo || null,
            signature: loan.signature || null,
            cosigner_signature: loan.cosigner_signature || null,
          });
        } catch (error) {
          console.error("Error fetching car loan data:", error);
        }
      }
    };
    fetchLoanData();
  }, [loanId, adminId, adminName]);

  const handleEditClick = () => {
    navigate(`/edit-car-loan/${loanId}`);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay-edit')) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-edit" onClick={handleOverlayClick}>
      <div className="modal-content-edit">
        <h3 className="edit-title">
          Car Loan
          <span className="action-icon">
            <FaEdit
              className="edit-loan"
              style={{ cursor: 'pointer' }}
              onClick={handleEditClick}
            />
          </span>
        </h3>
        <div className="form-content-section">
          <div className="step-sections-personal-details-sections">
          <h4>Personal Details</h4>
            <div className="form-row-step">
              <strong>Agent ID:</strong>
              <div className="value">{formData.created_id}</div>
            </div>

            <div className="form-row-step">
              <strong>Agent:</strong>
              <div className="value">{formData.created_by}</div>
            </div>

            <div className="form-row-step">
              <strong>Assign to:</strong>
              <div className="value">{formData.assigned_to}</div>
            </div>

            <div className="form-row-step">
              <strong>Lead Status:</strong>
              <div className="value">{formData.status}</div>
            </div>

            {formData.status === "Rejected" && (
              <div className="form-row-step">
                <strong>Rejected reason:</strong>
                <div className="value">{formData.rejected_reason}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Name:</strong>
              <div className="value">{formData.name}</div>
            </div>

            <div className="form-row-step">
              <strong>Date of Birth:</strong>
              <div className="value">{formattedDob}</div>
            </div>

            <div className="form-row-step">
              <strong>Marital Status:</strong>
              <div className="value">{formData.maritalstatus}</div>
            </div>

            <div className="form-row-step">
              <strong>Email:</strong>
              <div className="value">{formData.email}</div>
            </div>

            <div className="form-row-step">
              <strong>Phone Number:</strong>
              <div className="value">{formData.mobile}</div>
            </div>

            <div className="form-row-step">
              <strong>Address:</strong>
              <div className="value">{formData.current_address}</div>
            </div>

            <div className="form-row-step">
              <strong>City:</strong>
              <div className="value">{formData.city}</div>
            </div>

            <div className="form-row-step">
              <strong>State:</strong>
              <div className="value">{formData.state}</div>
            </div>

            <div className="form-row-step">
              <strong>Pincode:</strong>
              <div className="value">{formData.pincode}</div>
            </div>

            <div className="form-row-step">
              <strong>Emergency Contact Phone:</strong>
              <div className="value">{formData.emergency_contact_phone}</div>
            </div>
            <h4>Loan Details</h4>

            <div className="form-row-step">
              <strong>Loan Type:</strong>
              <div className="value">{formData.loan_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Requested Loan Amount:</strong>
              <div className="value">{formData.requested_loan_amount}</div>
            </div>

            <div className="form-row-step">
              <strong>Employee Type:</strong>
              <div className="value">{formData.employee_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Current Bank Name:</strong>
              <div className="value">{formData.current_bank_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Branch:</strong>
              <div className="value">{formData.branch}</div>
            </div>

            <div className="form-row-step">
              <strong>Account Type:</strong>
              <div className="value">{formData.account_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Account Number:</strong>
              <div className="value">{formData.account_number}</div>
            </div>

            <div className="form-row-step">
              <strong>Do you own a house?</strong>
              <div className="value">{formData.own_house}</div>
            </div>

            <div className="form-row-step">
              <strong>Current Loan:</strong>
              <div className="value">{formData.current_loan}</div>
            </div>

            <div className="form-row-step">
              <strong>Monthly Income:</strong>
              <div className="value">{formData.monthly_income}</div>
            </div>

            <h4>Vehicle Details</h4>
            <div className="form-row-step">
              <strong>Make & Model:</strong>
              <div className="value">{formData.make_model}</div>
            </div>


            <div className="form-row-step">
              <strong>Registered Year:</strong>
              <div className="value">{formData.registered_year}</div>
            </div>

            <div className="form-row-step">
              <strong>Registration Number:</strong>
              <div className="value">{formData.registration_number}</div>
            </div>
         </div>

          <div className="button-sections">
            <Row>
              <Col className="text-end">
                <Button
                  className="custom-back-button"
                  type="button"
                  onClick={onClose}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCarViewModal;
